import React, { Fragment } from 'react';
import GuideRole from "../../images/rule_guide.png"
import { Dialog, Transition } from '@headlessui/react';
import "react-responsive-carousel/lib/styles/carousel.css";
import { XCircleIcon } from '@heroicons/react/24/solid';

export function PreviewRole({ open, setOpen }) {

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => setOpen(false)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500/75 backdrop-filter backdrop-blur-sm transition-opacity" />
        </Transition.Child>

        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative rounded-3xl px-6 transform transition-all sm:my-8 lg:max-w-6xl 3xl:max-w-7xl sm:max-w-sm sm:p-12">
                <button className="absolute -right-10 3xl:-right-32 top-10 z-50" onClick={() => setOpen(false)}><XCircleIcon className="h-7 w-7 text-gray-500 hover:text-gray-600 transition-colors" /></button>
                <img src={GuideRole} alt="GuideRole" />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}